var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubcatsIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 6C7 6.55228 6.55228 7 6 7C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5C6.55228 5 7 5.44772 7 6Z",
  fill: "#636A7D"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 6C9 5.44772 9.44772 5 10 5H18C18.5523 5 19 5.44772 19 6C19 6.55228 18.5523 7 18 7H10C9.44772 7 9 6.55228 9 6Z",
  fill: "#636A7D"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 15C9 14.4477 9.44772 14 10 14H18C18.5523 14 19 14.4477 19 15C19 15.5523 18.5523 16 18 16H10C9.44772 16 9 15.5523 9 15Z",
  fill: "#636A7D"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M9 9C9 8.44772 9.44772 8 10 8H16C16.5523 8 17 8.44772 17 9C17 9.55228 16.5523 10 16 10H10C9.44772 10 9 9.55228 9 9Z",
  fill: "#636A7D"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M9 18C9 17.4477 9.44772 17 10 17H16C16.5523 17 17 17.4477 17 18C17 18.5523 16.5523 19 16 19H10C9.44772 19 9 18.5523 9 18Z",
  fill: "#636A7D"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M6 16C6.55228 16 7 15.5523 7 15C7 14.4477 6.55228 14 6 14C5.44772 14 5 14.4477 5 15C5 15.5523 5.44772 16 6 16Z",
  fill: "#636A7D"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubcatsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/subcats-icon.e2e60f1ce72ddca2d5b2dd562c84b624.svg";